import React from 'react';
import './SearchInput.css'

const SearchInput = (props) => {
    return ( 
        <div className='SearchInput'>
            <p className='Label'>
                {props.Label}
            </p>
            <input className='InputField' type={props.InputType} placeholder={props.Placeholder} />
        </div>
     );
}
 
export default SearchInput;